const FORM_STATUSES = {
    inactive: 'Inactive',
    active: 'Active'
};

const FORM_STATUSES_NAMES = {
    [FORM_STATUSES.inactive]: 'Inactive',
    [FORM_STATUSES.active]: 'Active'
};

export {
    FORM_STATUSES,
    FORM_STATUSES_NAMES
};